var _path, _mask, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnelPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 68,
    viewBox: "0 0 76 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9107 3.03046C36.5844 1.35678 39.2979 1.35678 40.9716 3.03046L68.8518 30.9107C70.5255 32.5843 70.5255 35.2979 68.8518 36.9716L40.9716 64.8518C39.2979 66.5255 36.5844 66.5255 34.9107 64.8518L7.0305 36.9716C5.35682 35.2979 5.35682 32.5843 7.03049 30.9107L34.9107 3.03046Z",
    fill: "#00C6A2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 33,
    height: 32
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.9412,
    y: 21,
    width: 32,
    height: 32,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2132 21.9846H25.9258V24.6061L35.9315 37.7386H40.2075L50.2132 24.6061V21.9846ZM51.1978 24.9385L40.6952 38.7233H35.4438L24.9412 24.9385V21H51.1978V24.9385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4437 37.5742C35.7156 37.5742 35.936 37.7946 35.936 38.0665V51.7111L40.2027 49.5778V38.0665C40.2027 37.7946 40.4231 37.5742 40.695 37.5742C40.9669 37.5742 41.1873 37.7946 41.1873 38.0665V49.882C41.1873 50.0685 41.082 50.239 40.9152 50.3224L35.6638 52.948C35.5112 53.0243 35.33 53.0162 35.1848 52.9265C35.0397 52.8368 34.9514 52.6783 34.9514 52.5077V38.0665C34.9514 37.7946 35.1718 37.5742 35.4437 37.5742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4335 24.9385C25.4335 24.6666 25.6539 24.4462 25.9258 24.4462H50.5414C50.8133 24.4462 51.0337 24.6666 51.0337 24.9385C51.0337 25.2104 50.8133 25.4308 50.5414 25.4308H25.9258C25.6539 25.4308 25.4335 25.2104 25.4335 24.9385Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 34C12 37.3137 9.31371 40 6 40C2.68629 40 0 37.3137 0 34C0 30.6863 2.68629 28 6 28C9.31371 28 12 30.6863 12 34Z",
    fill: "#9088DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 39C8.76142 39 11 36.7614 11 34C11 31.2386 8.76142 29 6 29C3.23858 29 1 31.2386 1 34C1 36.7614 3.23858 39 6 39ZM6 40C9.31371 40 12 37.3137 12 34C12 30.6863 9.31371 28 6 28C2.68629 28 0 30.6863 0 34C0 37.3137 2.68629 40 6 40Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 34C76 37.3137 73.3137 40 70 40C66.6863 40 64 37.3137 64 34C64 30.6863 66.6863 28 70 28C73.3137 28 76 30.6863 76 34Z",
    fill: "#9088DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 39C72.7614 39 75 36.7614 75 34C75 31.2386 72.7614 29 70 29C67.2386 29 65 31.2386 65 34C65 36.7614 67.2386 39 70 39ZM70 40C73.3137 40 76 37.3137 76 34C76 30.6863 73.3137 28 70 28C66.6863 28 64 30.6863 64 34C64 37.3137 66.6863 40 70 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelPreview);
export default __webpack_public_path__ + "static/media/FunnelPreview.248657926ff60c4d7aca10f9e5da6db9.svg";
export { ForwardRef as ReactComponent };